/**
 * Central configuration for the Application Console.
 *
 * Adding a new application type (e.g. "airflow") requires ONLY adding an
 * entry here — no new components, no new plugin, no new backend.
 *
 * `key` MUST match the value used in catalog entities as `spec.type`.
 */
export interface ApplicationTypeConfig {
  /** Matches Component entity `spec.type` in the catalog. Lowercase, no spaces. */
  key: string;
  /** Display title shown in sidebar, page headers, etc. */
  title: string;
  /** Optional icon key resolved via the app's icon registry (see plugin.ts). */
  icon?: string;
}

export const applicationTypes: ApplicationTypeConfig[] = [
  { key: 'flink', title: 'Flink', icon: 'flink' },
  { key: 'kafka', title: 'Kafka', icon: 'kafka' },
  { key: 'grafana', title: 'Grafana', icon: 'grafana' },
  { key: 'doris', title: 'Doris', icon: 'doris' },
  { key: 'nifi', title: 'NiFi', icon: 'nifi' },
  { key: 'kibana', title: 'Kibana', icon: 'kibana' },
];

export function getApplicationType(key: string): ApplicationTypeConfig | undefined {
  return applicationTypes.find(t => t.key === key);
}

/**
 * The annotation Backstage entities use to declare their environment.
 * Kept as a single constant so the convention lives in exactly one place.
 *
 * Example:
 *   metadata:
 *     annotations:
 *       company.com/environment: production
 */
export const ENVIRONMENT_ANNOTATION = 'company.com/environment';

/** Annotation used for the "Open Application" endpoint link, if not using metadata.links. */
export const ENDPOINT_LINK_TITLE = 'Open Application';
export const CODEBASE_LINK_TITLE = 'Codebase';
export const DEPLOYMENT_LINK_TITLE = 'Deployment Source';
export const DOCS_LINK_TITLE = 'Documentation';
